/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignDatetimeOperation
 */
export interface AssignDatetimeOperation {
    /**
     * 
     * @type {number}
     * @memberof AssignDatetimeOperation
     */
    valueMilliseconds: number;
}

/**
 * Check if a given object implements the AssignDatetimeOperation interface.
 */
export function instanceOfAssignDatetimeOperation(value: object): value is AssignDatetimeOperation {
    if (!('valueMilliseconds' in value) || value['valueMilliseconds'] === undefined) return false;
    return true;
}

export function AssignDatetimeOperationFromJSON(json: any): AssignDatetimeOperation {
    return AssignDatetimeOperationFromJSONTyped(json, false);
}

export function AssignDatetimeOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignDatetimeOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'valueMilliseconds': json['valueMilliseconds'],
    };
}

export function AssignDatetimeOperationToJSON(value?: AssignDatetimeOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'valueMilliseconds': value['valueMilliseconds'],
    };
}

